import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div data-testid="payment-cancel-page" className="max-w-md w-full p-8 rounded-2xl border border-border/70 bg-card/60 text-center fade-up">
        <XCircle className="w-14 h-14 mx-auto text-destructive mb-4" />
        <h2 className="font-display font-bold text-2xl mb-2">Payment cancelled</h2>
        <p className="text-sm text-muted-foreground mb-6">No charge was made. You can try again from your dashboard.</p>
        <Button data-testid="cancel-back-btn" onClick={() => nav("/dashboard")} className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90">
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
}
